import { guardChildNodeByType } from '@utils/ast';
import { configRefs, transformGradeLevel } from '@utils/constants';

const parseCardsComponent = (node) => {
  const cardsContainer = Array.from(node.childNodes).find(
    guardChildNodeByType("Items")
  );
  if (!cardsContainer) {
    return null;
  }
  const cards = Array.from(cardsContainer.children).map((it) => parseCardItem(it)).filter((it) => it !== null);
  if (cards.length === 0) {
    return null;
  }
  return {
    nodeType: "cards-component",
    id: node.getAttribute("id") ?? void 0,
    meta: {
      title: node.getAttribute("title") ?? ""
    },
    options: {
      display: extractDisplayType(node.getAttribute("display")),
      enableFilters: node.getAttribute("showFilters") === "true"
    },
    cards,
    link: (() => {
      const href = node.getAttribute("pageLink");
      const label = node.getAttribute("pageLinkText");
      if (href && label) {
        return { href, label };
      }
    })()
  };
};
function parseCardItem(node) {
  const gradesNode = Array.from(node.childNodes).find(
    guardChildNodeByType("Grades")
  );
  const grades = Array.from((gradesNode == null ? void 0 : gradesNode.children) ?? []).map((grade) => grade.textContent).filter((it) => typeof it === "string");
  return {
    id: node.getAttribute("id") ?? "",
    title: node.getAttribute("title") ?? "",
    description: node.getAttribute("description") ?? "",
    type: node.getAttribute("type") ?? "",
    imageSrc: `${configRefs.apis.pm2.media.dangerouslyAssertSyncValue()}/${node.getAttribute(
      "vignette"
    )}`,
    link: {
      portal: {
        id: node.getAttribute("portalId") ?? "",
        hostname: node.getAttribute("portalHostname") ?? ""
      },
      path: node.getAttribute("path") ?? ""
    },
    meta: {
      courseCount: Number(node.getAttribute("lessons")),
      grades: grades.map((grade) => transformGradeLevel(grade)),
      label: node.getAttribute("itemLabel") ?? void 0
    }
  };
}
function extractDisplayType(displayMode) {
  switch (displayMode) {
    case "grid":
    case "slider":
      return displayMode;
    default:
      console.warn(
        "parseCards(): failed to extract displayType from backend, falling back to grid display."
      );
      return "grid";
  }
}
const cardsComponentParsers = {
  cards: parseCardsComponent
};
const cardsComponentInTeacherSectionParsers = {
  cards: (node, context) => {
    var _a;
    const base = parseCardsComponent(node);
    if (!base) {
      return null;
    }
    return {
      ...base,
      meta: {
        title: "Arbejd videre"
      },
      options: {
        display: "slider",
        enableFilters: false,
        titleAlignment: (_a = context.extra) == null ? void 0 : _a["titleAlignment"]
      }
    };
  }
};

export { cardsComponentInTeacherSectionParsers, cardsComponentParsers };
//# sourceMappingURL=component.cards.js.map
